/**
 * Microsoft Clarity deep-link helper (PE-1830).
 *
 * Per-merchant Clarity project ids are stored on the merchant record
 * (`merchant.clarityProjectId`, served by Watchman) — a merchant admin resolves
 * only their own merchant; a TCS admin resolves whichever merchant they view.
 */

/** Deep link to a Clarity project's dashboard (opens in the Clarity web app). */
export function clarityDashboardUrl(projectId: string): string {
  return `https://clarity.microsoft.com/projects/view/${projectId}/dashboard`;
}
